import { StreamActions } from "@hotwired/turbo"
import { setup as setupStreamActions } from "./stream_actions"
setupStreamActions(StreamActions);
